package horcrux.frontend.common.views.collections.importdocuments

import horcrux.common.api.dtos.types.DocumentName
import horcrux.frontend.common.views.components.input.editTextField
import react.ReactNode

val EditDocumentName = { value: String -> DocumentName(value) }.editTextField {
    this.label = ReactNode("Document Name")
}

